import { t } from "../i18n";

const missionId = (value) => {
  const id = Number(value);
  return Number.isSafeInteger(id) && id > 0 ? id : null;
};

export const diagnosisRunOptions = (runs, date) =>
  (Array.isArray(runs) ? runs : [])
    .filter((run) => run.date === date && missionId(run.missionLogId) != null)
    .map((run) => ({
      id: missionId(run.missionLogId),
      time: run.time ?? "",
      label: `${date.replace(/-/g, ".")} ${run.time ?? ""}`.trim(),
    }))
    .sort((a, b) => a.id - b.id);

// An absent run does not prove a different date. The date-scoped API includes
// running/aborted missions as soon as they have diagnosis results.
export const resolveDiagnosisUpdate = ({
  runs, updatedMissionId, currentMissionId, selectedDate, selectionLocked,
}) => {
  const updatedId = missionId(updatedMissionId);
  const currentId = missionId(currentMissionId);
  if (updatedId == null) return { type: "ignore" };
  const run = (Array.isArray(runs) ? runs : []).find(
    (item) => missionId(item.missionLogId) === updatedId
  );
  if (!run || !/^\d{4}-\d{2}-\d{2}$/.test(run.date ?? "")) {
    // 문구는 부를 때 현재 언어로 만든다(모듈 로드 시점에 고정하지 않는다).
    return { type: "notify", message: t("map.diagnosis.newResultUnresolved") };
  }
  if (run.date !== selectedDate) {
    return { type: "notify", message: t("map.diagnosis.newResultOtherDate") };
  }
  if (updatedId === currentId) return { type: "refresh" };
  const options = diagnosisRunOptions(runs, selectedDate);
  const latestId = options[options.length - 1]?.id;
  if (selectionLocked || (currentId != null && updatedId < currentId) || updatedId !== latestId) {
    return { type: "notify", message: t("map.diagnosis.newResultOtherRun") };
  }
  return { type: "select", item: options.find((item) => item.id === updatedId) };
};
